import React, { Component } from 'react'; //different
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Main from './main';
import Popup from './popup';
import Logout from './logout';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import io from "socket.io-client";
import Swal from 'sweetalert2'
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tblPopupMenu1: [],
      tblPopupMenu: [],
      tblPopupMenu2: [],
    }
  }
  
  getpopup = async () => {
    // เช็คเวลาที่เก็บข้อมูลล่าสุดจากแคช
    const cachedData = localStorage.getItem('popupData');
    const cachedTime = localStorage.getItem('popupDataTime');

    // ถ้ามีข้อมูลแคชและแคชยังไม่หมดอายุ (30 นาที)
    if (cachedData && cachedTime && Date.now() - cachedTime < 30 * 60 * 1000) {
      // ใช้ข้อมูลจากแคช
      const parsedData = JSON.parse(cachedData);
      this.setState({
        tblPopupMenu1: parsedData.tblPopupMenu1,
        tblPopupMenu: parsedData.tblPopupMenu,
        tblPopupMenu2: parsedData.tblPopupMenu2,
      });
      console.log("Using cached data");
    } else {
      // ถ้าไม่มีแคช หรือแคชหมดอายุ
      instance.post("/api/v1/popuplist", {
        System: Systems,
        Cat_ID: 0,
        page: 1,
        type: 1
      }).then(async (res) => {
        if (res.data.status === 200) {
          // เก็บข้อมูลใหม่ลงในแคช
          const dataToCache = {
            tblPopupMenu1: res.data.message.tblPopupMenu1,
            tblPopupMenu: res.data.message.banklist,
            tblPopupMenu2: res.data.message.tblPopupMenu2,
          };
          localStorage.setItem('popupData', JSON.stringify(dataToCache));
          localStorage.setItem('popupDataTime', Date.now().toString());

          // อัปเดต state
          this.setState({
            tblPopupMenu1: dataToCache.tblPopupMenu1,
            tblPopupMenu: dataToCache.tblPopupMenu,
            tblPopupMenu2: dataToCache.tblPopupMenu2,
          });
          console.log("Data fetched and cached");
        }
      }).catch(async (err) => {
        // console.log(err);
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          });
          window.location.href = '/';
        }
      });
    }
  }

  callgetthemesv = async (Systems) => {
    const cacheKey = "theme_v1";            // ปรับชื่อ key ตามต้องการ
    const ttl = 24 * 60 * 60 * 1000;        // 24 ชั่วโมง (ปรับถ้าต้องการ 1 ชั่วโมง = 3600000)

    // 1) ถ้ามี cache ที่ยัง valid ให้ใช้ทันที (fast)
    const cached = this.getCache ? this.getCache(cacheKey, ttl) : null;
    if (cached) {
      // Apply cached theme right away
      document.body.setAttribute("data-theme", cached);
      this.setState({ ThmeseV: cached });
      // แต่ยังทำ background fetch เพื่อตรวจสอบ/รีเฟรช (stale-while-revalidate)
      this._fetchAndUpdateTheme(Systems, cacheKey).catch(err => console.error("theme background fetch:", err));
      return;
    }

    // 2) ถ้าไม่มี cache ให้รอ fetch ปกติ (first load)
    try {
      const res = await instance.post("/api/v1/getthemesv", { System: Systems });
      if (res.data.status === 200) {
        const theme = res.data.ThmeseV;
        document.body.setAttribute("data-theme", theme);
        this.setState({ ThmeseV: theme });
        // save cache
        if (this.setCache) this.setCache(cacheKey, theme);
      }
    } catch (err) {
      console.error("callgetthemesv error:", err);
      // ถ้า fetch ล้มเหลว ไม่ต้องทำอะไรเพิ่มเติม (ถ้ามี cached value จะใช้ของเก่า)
    }
  }

  async componentDidMount() {
    const endpoint = "https://apixgen.javisx.com:9000";
    const socket = io.connect(endpoint);
    var roomid = Systems;
    var obj = { roomid }
    var json = JSON.stringify(obj);
    socket.on('connect', function (data) {
      var obj = { roomid }
      var json = JSON.stringify(obj);
      socket.emit('new', json);
    });
    await this.callgetthemesv(Systems);
    await this.getpopup();
  }
  render() {

    return (
      < >
        <BrowserRouter >
          <Routes>
            <Route path="/*" element={<Main />} />

            <Route path="/logout" element={<Logout />} />
            {/* <Route path="/slot" element={<Slot />} />
              <Route path="/sport" element={<Sport />} /> */}
            {/* <Route path="/loss" element={<Loss />} /> */}
            {/* <Route path="/deposit" element={<Deposit />} /> */}
            {/* <Route path="/signin" element={<Signin />} />
              <Route path="/arcade" element={<Arcade />} />
              <Route path="/statement" element={<Statement />} />
              <Route path="/freegame" element={<Freegame />} />
              <Route path="/listgamealldemo/*" element={<Linklistalldemo />} />
              <Route path="/register/*" element={<Register />} />
              <Route path='/Paoyingchub' element={<Promotion />} /> */}
          </Routes>
        </BrowserRouter>
        <script id="b-loading" type="text/template">
          <div className="x-dice-container py-5 m-auto d-flex">
            <div id="dice" className="mx-auto">
              <div className="side front">
                <div className="dot center bg-danger"></div>
              </div>
              <div className="side front inner"></div>
              <div className="side top">
                <div className="dot dtop dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side top inner"></div>
              <div className="side right">
                <div className="dot dtop dleft"></div>
                <div className="dot center"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side right inner"></div>
              <div className="side left">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side left inner"></div>
              <div className="side bottom">
                <div className="dot center"></div>
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side bottom inner"></div>
              <div className="side back">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
                <div className="dot center dleft"></div>
                <div className="dot center dright"></div>
              </div>
              <div className="side back inner"></div>
              <div className="side cover x"></div>
              <div className="side cover y"></div>
              <div className="side cover z"></div>
            </div>
          </div>
        </script>
        <script id="loading" type="text/template">
          <div className="x-dice-container py-5 m-auto d-flex">
            <div id="dice" className="mx-auto">
              <div className="side front">
                <div className="dot center bg-danger"></div>
              </div>
              <div className="side front inner"></div>
              <div className="side top">
                <div className="dot dtop dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side top inner"></div>
              <div className="side right">
                <div className="dot dtop dleft"></div>
                <div className="dot center"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side right inner"></div>
              <div className="side left">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side left inner"></div>
              <div className="side bottom">
                <div className="dot center"></div>
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side bottom inner"></div>
              <div className="side back">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
                <div className="dot center dleft"></div>
                <div className="dot center dright"></div>
              </div>
              <div className="side back inner"></div>
              <div className="side cover x"></div>
              <div className="side cover y"></div>
              <div className="side cover z"></div>
            </div>
          </div>
        </script>
        <ToastContainer />
        <Popup />


      </>
    );
  }
}

export default App;
